import { Component, OnInit, ViewChild,ViewEncapsulation } from '@angular/core';
import { FormArray,FormGroup,FormControl, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { LoadService } from '../../services/load.service';
import { LocationService } from '../../services/location.service';
import { PackingEcService } from '../../services/packingec.service';
import { PalletsService } from '../../services/pallets.service';
import { ProductionOrderService } from '../../services/productionOrders.service';
import { TagsService } from '../../services/tags.service';
import { StockService } from '../../services/stock.service';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { listLocales } from 'ngx-bootstrap/chronos';
import { InventoryService } from '../../services/inventory.service';

@Component({
  selector: 'inventarios',
  templateUrl: './inventarios.component.html',
  styleUrls: ['./inventarios.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class InventariosComponent implements OnInit {
  @ViewChild(ModalDirective) public lgModal: ModalDirective;
  public load:number;
  public myAngularxQrCode: string;
  public primeracarga:boolean;
  public isopen:boolean;
  public alert:string;
  public data_list:any;
  public links: any;
  public meta: any;
  public title:string;
  public isNew:boolean;
  public signupForm:FormGroup;
  public signupForm2:FormGroup;
  public signupForm3:FormGroup;
  public signupForm4:FormGroup;
  public ubicaciones:any[];
  public etapa : number;
  public contadortags:number;
  public packingpallet: any[];
  public buscando: boolean;
  public posicioneslibres : any[];
  public palletlibres :any[];
  public palletQR:string;
  public clienteQR:string;

  constructor(private _productionOrderService:ProductionOrderService,private datePipe: DatePipe,private _inventoryService:InventoryService,private _stockService:StockService,private _palletsService:PalletsService,private _tagsService:TagsService,private _packingecService:PackingEcService,private _locationService:LocationService,private _localeService: BsLocaleService,private _loaddata: LoadService) {
    this.isopen = false;
    this.alert = "";
    this.primeracarga = false;
    this.myAngularxQrCode = ' ';
    this.ubicaciones = [];
    this.contadortags = 0;
    this.etapa = 1;
    this.packingpallet = [];
    this.buscando = false;
    this.posicioneslibres = [];
    this.palletlibres = [];
    this.palletQR = '';
    this.clienteQR = '';
  }

  ngOnInit() {
    this._loaddata.loadChange(10);
    this._localeService.use('es');
    this._loaddata.loadCurrent.subscribe(a=> this.load = a);
    this.signupForm = new FormGroup({
      'ubicacion':new FormControl(null,Validators.required),
      'nombreubicacion':new FormControl(''),
      'biofouling':new FormControl(),
      'nombrebiofouling':new FormControl(),
    });

    this.signupForm.patchValue({
      'biofouling':false,
      'nombrebiofouling':'Sin Biofouling'
    })

    this.signupForm2 = new FormGroup({
      'busqueda': new FormControl("")
    });

    this.signupForm3 = new FormGroup({
      'busqueda': new FormControl(""),
      'posicion':new FormControl(null,Validators.required),
      'nombreposicion':new FormControl(''),
      'op':new FormControl('',Validators.required),
      'nombreop':new FormControl(''),
      'pallet':new FormControl(null),
      'nombrepallet':new FormControl(''),
    });

    this.loadUbicaciones();
  }

  /**
  * carga el listado de todas las ubicaciones
  */
  loadUbicaciones():void{
    this.alert = ""
    this.isopen = false;
    this._loaddata.loadChange(50);
    this._locationService.get().subscribe((response:any) => {
      this.ubicaciones = response.data;
      this.loadData();
    },
    (error) => {
      this.showError(error.message);
    });
  }

  /**
  * Carga el menu de movimientos
  */
  loadData():void{
    this.etapa = 1;
    this._loaddata.loadChange(100);
    this.alert = "Carga Correcta."
    this.isopen = true;
    if(this.primeracarga === false){
      this.primeracarga = !this.primeracarga;
    }
  }

  onSelectedUbicacion(){
    for(let ubi of this.ubicaciones){
      if(ubi.id == this.signupForm.get('ubicacion').value){
        this.signupForm.patchValue({
          'nombreubicacion':ubi.attributes.name
        });
        break;
      }
    }
  }

  reverse(etapa:number){
    if(etapa == 2){
      this.etapa = 1;
    }
    else if(etapa == 3){
      this.etapa = 2;
    }
    else if(etapa == 4){
      this.etapa = 3;
    }
    else if(etapa == 5){
      this.etapa = 4;
    }
    else if(etapa == 6){
      this.etapa = 5;
    }
    else if(etapa == 7){
      this.etapa = 6;
    }
  }

  forward(etapa:number){
    if(etapa == 1){
      this.etapa = 2;
    }
    else if(etapa == 2){
      this.etapa = 3;
      this.loadFreePositions();
    }
    else if(etapa == 3){
      this.etapa = 4;
    }
    else if(etapa == 4){
      this.etapa = 5;
    }
    else if(etapa == 5){
      this.etapa = 6;
    }
    else if(etapa == 6){
      this.etapa = 7;
    }
  }

  onChangeBiofouling(){
    if(this.signupForm.get('biofouling').value == false){
      this.signupForm.patchValue({
        'nombrebiofouling':'Con Biofouling',
        'biofouling':true
      });
    }
    else if(this.signupForm.get('biofouling').value == true){
      this.signupForm.patchValue({
        'nombrebiofouling':'Sin Biofouling',
        'biofouling':false
      });
    }
  }

  onReadRealTags():void{
    let qr = this.signupForm2.get('busqueda').value;
    let prefijo = 0;
    let sufijo = 0;
    let guion = 0;
    let variable = '';
    let encontrada = false;
    this.alert = '';

    if(qr.charAt(0) == '[' && qr.charAt(1) == 'i' && qr.charAt(2) == '¡'){
      qr = qr.substring(3);
    }

    for(let char of qr){
      if(char != '-'){
        variable += char
      }
      else if(guion == 0){
        prefijo = parseInt(variable);
        variable = '';
        guion = 1;
      }
      else if(guion == 1){
        sufijo = parseInt(variable);
        variable = '';
        guion = 2;
      }
    }

    if(sufijo > 0 && sufijo < 92 && prefijo > 0 &&  isNaN(sufijo) == false && isNaN(prefijo) == false){
      for(let qr of this.packingpallet){
        if(qr.sufijo == sufijo && qr.prefijo == prefijo){
          encontrada = true;
          this.alert = 'Etiqueta QR '+prefijo+'-'+sufijo+' duplicada en la lectura.';
          break;
        }
      }
      if(encontrada == false){
        if(this.packingpallet.length < 90){
          this.packingpallet = [...this.packingpallet,{'sufijo':sufijo,'prefijo':prefijo,'qr':qr,'repetida':false,'existe':true,'id':-1}];
        }
        else{
          this.alert ='Solo se permiten 90 cajas por pallet.'
        }
      }
      else if(encontrada == true){
        this.packingpallet = [...this.packingpallet,{'sufijo':sufijo,'prefijo':prefijo,'qr':qr,'repetida':true,'existe':true,'id':'duplicadaenlectura'}];
      }
    }
    else{
      this.alert += 'Error de lectura.';
    }

    this.signupForm2.reset();
    this.signupForm2.patchValue({
      'busqueda': '',
    });

    if(this.alert == ''){
      this.alert = 'Etiqueta QR '+prefijo+'-'+sufijo+' agregada.';
    }

    this.isopen = true;
  }

  onDeleteTag(i:number){
    let sufijo = this.packingpallet[i].sufijo;
    let prefijo = this.packingpallet[i].prefijo;
    this.alert = 'Etiqueta QR '+prefijo+'-'+sufijo+' eliminada.';
    this.isopen = true;
    this.packingpallet.splice(i,1);
  }

  onDeleteAll(){
    this.packingpallet = [];
  }

  onDeleteAllRed(){
    let packing = [];
    for(let caja of this.packingpallet){
      if(caja.repetida == true || caja.existe == false){

      }
      else{
        packing.push(caja);
      }
    }

    this.packingpallet = [...packing];
  }

  onCheckDB(){
    this.buscando = true;
    this.signupForm2.get('busqueda').disable();
    this.alert = 'Buscando etiquetas QR en el sistema.';
    this.isopen = true;
    this._loaddata.loadChange(40);
    let pos = 0;
    let that = this;

    for(let caja of this.packingpallet){
      setTimeout(() => {
        if(caja.id != 'duplicadaenlectura'){
          that._tagsService.getOnebyPrefixAndSuffix(caja.prefijo,caja.sufijo).subscribe(
            (response:any) => {
              if(response.data.length != 0){
                that.alert = 'Etiqueta QR '+caja.prefijo+'-'+caja.sufijo+' SI existe en el sistema.';
                caja.id = response.data[0].id;
                caja.existe = true;
                pos += 1;

                if(pos == that.packingpallet.length){
                  that.onCheckDB2();
                }
              }
              else{
                that.alert = 'Etiqueta QR '+caja.prefijo+'-'+caja.sufijo+' NO existe en el sistema.';
                pos += 1;
                caja.existe = false;

                if(pos == that.packingpallet.length){
                  that.onCheckDB2();
                }
              }
            },
            (error) => {
              that.alert = 'Etiqueta QR '+caja.prefijo+'-'+caja.sufijo+' NO existe en el sistema.';
              pos += 1;
              caja.existe = false;
              if(pos == that.packingpallet.length){
                that.onCheckDB2();
              }
            }
          );
        }
        else{
          pos += 1;
        }
      },300);
    }
  }

  onCheckDB2(){
    let pos = 0;
    this.alert = 'Buscando etiquetas QR duplicadas en el sistema.';
    this.isopen = true;
    this._loaddata.loadChange(70);
    let that = this;

    for(let caja of this.packingpallet){
      setTimeout(() => {
        if(caja.id != 'duplicadaenlectura'){
          if(caja.existe == true){
            that._stockService.getOneStock(caja.prefijo,caja.sufijo).subscribe(
              (response:any) => {
                that.alert = 'Etiqueta QR '+caja.prefijo+'-'+caja.sufijo+' SI esta duplicada en el sistema.';
                caja.repetida = true;
                pos += 1;

                if(pos == that.packingpallet.length){
                  that.onCheckDB3();
                }
              },
              (error) => {
                that.alert = 'Etiqueta QR '+caja.prefijo+'-'+caja.sufijo+' NO esta duplicada en el sistema.';
                pos += 1;
                caja.repetida = false;

                if(pos == that.packingpallet.length){
                  that.onCheckDB3();
                }
              }
            );
          }
          else{
            pos+=1;
            caja.repetida = false;
            if(pos == that.packingpallet.length){
              that.onCheckDB3();
            }
          }
        }
        else{
          pos+=1;
        }
      },300);
    }
  }

  onCheckDB3(){
    let problema = false;
    this.alert = 'Buscando etiquetas QR con problemas.';
    this.isopen = true;
    this._loaddata.loadChange(90);

    for(let caja of this.packingpallet){
      if(caja.existe == false || caja.repetida == true){
        problema = true;
        break;
      }
    }

    if(problema == true){
      this.alert = 'Analisis terminado con observaciones.';
      this._loaddata.loadChange(100);
      this.buscando = false;
      this.signupForm2.get('busqueda').enable();
    }
    else{
      this.forward(2);
      this.alert = 'Analisis terminado satisfactoriamente.'
      this._loaddata.loadChange(100);
      this.buscando = false;
      this.signupForm2.get('busqueda').enable();
    }
  }

  loadFreePositions(){
    this.posicioneslibres = [];
    this.alert = 'Buscando posiciones disponibles.';
    this.isopen = true;
    this._loaddata.loadChange(30);

    this._locationService.freePositionsFromLocation(this.signupForm.get('ubicacion').value).subscribe(
      (response:any) => {
        this.posicioneslibres = response.data;
      },
      (error) => {
        this.alert = 'No existen posiciones disponibles';
        this._loaddata.loadChange(100);
      }
    );
  }

  onReadOP(){
    this.alert = 'Buscando OP';
    this.isopen = true;
    this._loaddata.loadChange(30);
    this.palletlibres = [];
    let qr = this.signupForm3.get('busqueda').value;

    this._productionOrderService.getOneNumber(qr).subscribe((response:any) => {
      this.clienteQR = response.data[0].relationships.client.data.attributes.name;

      this.signupForm3.patchValue({
        'busqueda': '',
        'op':response.data[0].id,
        'nombreop':response.data[0].attributes.number
      });
      this.alert = 'OP cargada. Buscando Pallets relacionados.';
      this._loaddata.loadChange(60);
      this._palletsService.getEmptyPalletsByPrefix('P'+qr).subscribe((response:any) => {
        this.palletlibres = response.data;

        this.signupForm3.patchValue({
          'pallet':null,
          'nombrepallet':'P'+qr
        });
        this.alert = 'Pallet cargados.';
        this._loaddata.loadChange(100);
      },
      (error) => {
        this.showError(error.error.error);
      });
    },
    (error) => {
      this.showError(error.error.error);
    });
  }

  onSelectedPallet(){
    for(let pal of this.palletlibres){
      if(pal.id == this.signupForm3.get('pallet').value){
        this.signupForm3.patchValue({
          'nombrepallet':pal.attributes.number
        });
        break;
      }
    }
  }

  onSelectedPosition(){
    for(let pos of this.posicioneslibres){
      if(pos.id == this.signupForm3.get('posicion').value){
        this.signupForm3.patchValue({
          'nombreposicion':pos.attributes.name
        });
        break;
      }
    }
  }

  onSaveInventory(){
    this.buscando = true;
    this.alert = 'Generando petición.';
    this.isopen = true;
    this._loaddata.loadChange(40);
    //Crear pallet nuevo
    if(this.signupForm3.get('pallet').value == null){
      this.alert = 'Creando nuevo pallet relacionado con OP: '+ this.signupForm3.get('nombreop').value;
      let prov = this._palletsService.transformData4(this.signupForm3.get('nombrepallet').value);
      this._palletsService.save(prov).subscribe(
        (response:any) =>{
          this._loaddata.loadChange(60);
          this.onPrintPalletQR(response);
          this.onInsertInventory(response.id);
        },
        (error) => {
          this.showError(error.error.error);
          this.buscando = false;
        }
      );
    }
    //Usar pallet ya creado
    else{
      this.onInsertInventory(this.signupForm3.get('pallet').value);
    }
  }

  onPrintPalletQR(pallet){
    this.palletQR = pallet.attributes.number;
    let that = this;
    setTimeout(() => {
      that.print();
    },100);
  }

  /**
   * Abre una nueva ventana para imprimir las etiquetas QR contenidas
   * en printContents, que a su vez esta relacionado con print-section del html.
   */
    private print(): void {
      let printContents, popupWin;
      printContents = document.getElementById('print-section').innerHTML;
      popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
      popupWin.document.open();
      popupWin.document.write(`
        <html>
          <head>
            <style></style>
          </head>
          <body onload="window.print();window.close()">
            ${printContents}
          </body>
        </html>`
      );
      popupWin.document.close();
    }

  onInsertInventory(idpallet){
    this.alert = 'Ingresando cajas a pallet.';
    this._loaddata.loadChange(80);
    this.isopen = true;
    let that = this;
    let pos = 0;

    for(let caja of this.packingpallet){
      setTimeout(function(){
        let prov2 = that._stockService.transformData6(idpallet,caja.id,1,that.signupForm3.get('posicion').value,that.signupForm.get('nombrebiofouling').value);
        that._stockService.save(prov2).subscribe(
          (response:any) =>{
            let prov3= that._tagsService.transformData4(response.attributes.tag_id);
            that._tagsService.update2(response.attributes.tag_id,prov3).subscribe(
              (response:any) =>{
                pos += 1;
                if(pos == that.packingpallet.length){
                  that.alert = "Inventario ingresado sin problemas.";
                  that._loaddata.loadChange(100);
                  that.signupForm.reset();
                  that.signupForm2.reset();
                  that.signupForm3.reset();
                  that.etapa = 1;
                  that.packingpallet = [];
                  that.signupForm.patchValue({
                    'biofouling':false,
                    'nombrebiofouling':'Sin Biofouling'
                  });
                  that.buscando = false;
                }
              },
              (error) => {
                pos += 1;
                if(pos == that.packingpallet.length){
                  that.alert = "Actualización de etiquetas QR con errores.";
                  that._loaddata.loadChange(100);
                  that.buscando = false;
                }
                that.showError(error.error.error);
              }
            );
          },
          (error) => {
            pos += 1;

            if(pos == that.packingpallet.length){
              that.alert = "Ingreso de inventario con errores.";
              that._loaddata.loadChange(100);
              that.buscando = false;
            }

            that.showError(error.error.error);
          }
        );
      }, 100);
    }
  }

  /**
  * Cierra el modal
  */
  hideChildModal(): void {
    this.lgModal.hide();
  }

  /**
  * Cierra el mensaje de alerta.
  */
  onClosed(): void {
    this.isopen = false;
  }

  /**
  * Muestra un error
  * @param  msg mensaje del error
  */
  showError(msg:string){
    if(msg == undefined){
      this.alert = 'No tiene permisos para realizar la acción.';
    }
    else{
      this.alert = msg;
    }
    this._loaddata.loadChange(100);
    this.isopen =true;
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/inventarios/inventarios.component.ts